import { unparse } from 'papaparse'
import { CSV_SEPARATOR } from '@/const/common'
import { getCurrentDate } from './dates'

export const sanitizeFileName = (name: string) => {
  return name.replaceAll(/[\,\/]/g, '').replaceAll(/[^a-z0-9\-]/gi, '_').toLowerCase()
}

export const exportCSV = <T>(name: string, fields: string[], data: T[]) => {
  const csv = unparse({ fields, data }, { delimiter: CSV_SEPARATOR })

  const blob = new Blob([csv], { type: 'text/csv;charset=UTF-8' })
  const url = URL.createObjectURL(blob)

  const link = document.createElement('a')
  link.setAttribute('href', url)
  link.setAttribute(
    'download',
    `${sanitizeFileName(name)}${getCurrentDate({ withTime: true })}.csv`,
  )
  document.body.appendChild(link)
  link.click()
  link.remove()
}
